// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__16cp_","errorLogs":"styles_errorLogs__3BgE8"};